import { Component, OnInit } from '@angular/core';
import { AnnouncementService, ChildService, MemberQuery, MemberDetails } from '@fgb/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom, Observable } from 'rxjs';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit {
  memberDetails$: Observable<MemberDetails | undefined>;
  public discountURL: string = '';
  modal: NgbModalRef;
  populations = Populations;

  constructor(
    private modalService: NgbModal,
    private announcementService: AnnouncementService,
    private childService: ChildService,

    private memberQuery: MemberQuery
  ) {}

  ngOnInit() {
    firstValueFrom(this.announcementService.fetchAnnouncements());
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
  }

  confirmRegisterModal(content: any) {
    this.modal = this.modalService.open(content, { size: 'md', centered: true, modalDialogClass: 'guardian-register-modal' });
  }

  becomeGuardian(): void {
    firstValueFrom(this.childService.registerAsGuardian()).then(() => {
      this.modal.close();
      // reload is necessary so canMatch can run again and redirect to guardian page
      location.reload();
    });
  }
}
